import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: 'profile',
    component: () => import(/* webpackChunkName: "base-layout" */ '@/layouts/BaseLayout.vue'),
    children: [
        {
            path: '',
            name: 'profile-edit',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                // No lleva :id en la url (es siempre el perfil del usuario
                // autenticado) — showOwnUserId le indica a Breadcrumbs.vue que
                // debe mostrar el id del usuario en sesion (auth/getUserId)
                // junto al texto de este breadcrumb, sin tocar la ruta.
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.profile-edit',
                        isActive: true,
                        showOwnUserId: true
                    }
                ]
            },
            component: () => import(/* webpackChunkName: "users-edit" */ '@/modules/configurations/profile/views/Edit.vue')
        },
    ]
}